import { z } from "zod";
import { Taxonomy } from "@common/categories";
import {
    AccountClass,
    AccountType,
} from "@common/constants/domains/accounting/accounts";

export const categoryCoaMappingSchema = z.object({
    taxonomy: z.nativeEnum(Taxonomy),
    /** User-facing category name, `Parent > Child` for subcategories. */
    categoryPath: z.string(),
    accountClass: z.nativeEnum(AccountClass),
    allowedAccountTypes: z.array(z.nativeEnum(AccountType)),
    /** Null while the taxonomy has no account for this entity. */
    accountId: z.string().uuid().nullable(),
    reasoning: z.string().nullable(),
});

export type CategoryCoaMapping = z.infer<typeof categoryCoaMappingSchema>;

export const categoryCoaMappingsResponseSchema = z.object({
    mappings: z.array(categoryCoaMappingSchema),
    /** Accounts of the entity that a taxonomy can be mapped to. */
    assignableAccountIds: z.array(z.string().uuid()),
});

export type CategoryCoaMappingsResponse = z.infer<
    typeof categoryCoaMappingsResponseSchema
>;

export const updateCategoryCoaMappingBodySchema = z.object({
    accountId: z.string().uuid().nullable(),
});

export type UpdateCategoryCoaMappingBody = z.infer<
    typeof updateCategoryCoaMappingBodySchema
>;
